import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Borusan Otomotiv Group',
  logo: { name: 'Borusan Otomotiv', src: '/logo/borusanotomotivcard.png' },
  // "Munnink", not "Munnik", and "Aslı" with the dotless i: that is how
  // digitopia.co's own Borusan story page sets her name in its prose and under
  // its quote, and how the portrait supplied with that page's capture on
  // 2026-08-28 is filenamed. Changed here so her card and her story page agree;
  // the *file* keeps the older spelling, being a manifest key rather than a
  // name. Flagged in that story's `check` — see content/stories.ts.
  portrait: { src: '/photo/portrait-asli-de-munnik.png', alt: 'Aslı de Munnink' },
  quote: [
    'We required a digital maturity evaluation within these 6 dimensions; Governance, '
    + 'Customer, People, Innovation, Marketing, and Technology, which Digitopia includes in '
    + 'their methodology. Digitopia was the only one to answer all of these prerequisites.',
    'Digital maturity is not a job that should be evaluated once a year and then put on the '
    + 'shelves to collect dust. Evaluating our actions every three months and six months '
    + 'allows us to see our progress and motivates us even more for our long-term goals.',
  ],
  attribution: 'Aslı de Munnink, CDO',
  story: 'borusan-otomotiv-grup',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 8
